export { default } from './AdminsPage';
export { default as NewAdminPage } from './NewAdminPage';
